import { DollarApollo } from "vue-apollo/types/vue-apollo";
import { FetchResult } from "apollo-link";
import Mutation from "./mutation.gql";

export interface RawResult {
  updateGroup: boolean;
}

export type Args = {
  groupId: string;
  name?: string;
  isPrivileged?: boolean;
  allowRescueOperations?: boolean;
  isDeleted?: boolean;
};

export const updateGroup = async <V>(
  apollo: DollarApollo<V>,
  args: Args
): Promise<FetchResult<RawResult>> => {
  const {
    groupId,
    name,
    isPrivileged,
    allowRescueOperations,
    isDeleted
  } = args;
  const result = apollo.mutate<RawResult>({
    mutation: Mutation,
    variables: {
      groupId,
      name,
      isPrivileged,
      allowRescueOperations,
      isDeleted
    }
  });
  await apollo.provider.defaultClient.cache.reset();
  return result;
};
